import TextField, { TextFieldProps } from '../TextField'
import { TWO_FACTOR_CODE_LENGTH } from './TwoFactorCodeField.utils'

const TwoFactorCodeField = (props: TextFieldProps) => (
  <TextField
    fullWidth
    autoFocus
    autoComplete="one-time-code"
    placeholder={'0'.repeat(TWO_FACTOR_CODE_LENGTH)}
    inputProps={{
      inputMode: 'numeric',
      maxLength: TWO_FACTOR_CODE_LENGTH,
      style: {
        textAlign: 'center',
        letterSpacing: '0.75em',
        fontSize: '1.5rem',
        paddingLeft: '0.75em',
      },
    }}
    InputLabelProps={{
      sx: {
        '&:not(.MuiInputLabel-shrink)': {
          transform: 'translate(14px, 22px) scale(1)',
        },
      },
    }}
    {...props}
  />
)

export default TwoFactorCodeField
